import errorWithCode from './error-with-code';

export const env = process.env.NODE_ENV || 'development';
export const isProd = env === 'production';
export const isStaging = env === 'staging';
export const isDev = env === 'development';

export const isLocal = !!process.env.IS_OFFLINE || !!process.env.IS_LOCAL;

export const mongoURL = process.env.MONGO_URL;
export const sqsPrefixUrl = process.env.SQS_PREFIX_URL;

export const serverBaseURL = (() => {
  if (env === 'production') return process.env.SERVER_BASE_URL || 'https://api.deens.com';
  if (env === 'staging') return process.env.SERVER_BASE_URL || 'https://staging-api.deens.com';
  return process.env.SERVER_BASE_URL || 'http://api.please.docker';
})();

/**
 * Validates if MONGO_URL is present
 */
export function validateMongoEnvVars() {
  if (!mongoURL) throw errorWithCode(500, 'MONGO_URL environment var not set');
}

export function validateSqsPrefixUrl() {
  if (!sqsPrefixUrl) throw errorWithCode(500, 'env var SQS_PREFIX_URL not passed');
}

export const enableAnalytics = (() => {
  if (isProd) return true;
  if (process.env.ENABLE_ANALYTICS === '1') return true;
  return false;
})();

export const segmentWriteKey = (() => {
  if (enableAnalytics && !process.env.SEGMENT_IO_KEY) {
    throw errorWithCode(500, 'env var SEGMENT_IO_KEY not passed');
  }
  return process.env.SEGMENT_IO_KEY || '';
})();
